import { fourtyFiveDeg, ninetyDeg, oneEightyDeg, pipi } from '@baseValues'

export function calcRelativeRotation({
  rotationA,
  beta,
  rotationB,
  dot,
  cross,
  absoluteCross,
}: Props): number {
  /**
   * cd
   * ++
   * +-
   * -+
   * --
   */

  if (!beta && beta === 0) return 0
  if (!absoluteCross && absoluteCross === 0) return 0
  const dirZ = Math.sign(Math.cos(rotationB ?? 0))

  const rotAMinusBeta = rotationA - beta
  const rotAPlusBeta = rotationA + beta

  if (cross === 0) {
    return 0
  }

  if (cross > 0 && dot > 0) {
    if (absoluteCross > 0) {
      return rotAMinusBeta
    }
    if (absoluteCross < 0) {
      return rotAPlusBeta
    }
  }
  if (cross > 0 && dot < 0) {
    if (absoluteCross > 0) {
      return rotAMinusBeta
    }
    if (absoluteCross < 0) {
      return rotAPlusBeta
    }
  }
  if (cross < 0 && dot >= 0) {
    if (absoluteCross > 0) {
      return rotAMinusBeta
    }
    if (absoluteCross < 0) {
      return rotAPlusBeta
    }

    return rotAMinusBeta
  }
  if (cross < 0 && dot < 0) {
    if (dirZ < 0) {
      if (absoluteCross < 0) {
        return rotAPlusBeta
      }
      if (absoluteCross > 0) {
        return rotAMinusBeta
      }
    }
    if (absoluteCross < 0) {
      return rotAPlusBeta
    }
    if (absoluteCross > 0) {
      return rotAMinusBeta
    }
  }

  if (rotationA === ninetyDeg) {
    if (rotationB === 0) {
      return -fourtyFiveDeg
    }
    return fourtyFiveDeg
  }
  if (rotationA === oneEightyDeg) {
    if (rotationB === ninetyDeg) {
      return -fourtyFiveDeg
    }
    return fourtyFiveDeg
  }
  if (rotationA === -ninetyDeg) {
    if (rotationB === 0) {
      return fourtyFiveDeg
    }
    return -fourtyFiveDeg
  }
  if (rotationA === 0 || rotationA === pipi) {
    if (rotationB === -ninetyDeg) {
      return -fourtyFiveDeg
    }
    return fourtyFiveDeg
  }

  return 2
}
type Props<T extends number = number> = {
  rotationA: T
  beta: T
  cross: T
  absoluteCross: T
  dot: T
  rotationB?: T
}
export function calcRelativeRotationprevWall({
  rotationA,
  beta,
  absoluteCross,
  cross,
  dot,
}: Props): number {
  /**
   * cd
   * ++
   * +-
   * -+
   * --
   */
  if (!beta && beta === 0) return 1
  if (!absoluteCross && absoluteCross === 0) return 0
  const minusRotAMinusBeta = -rotationA - beta
  const rotAMinusBeta = rotationA - beta
  const rotAPlusBeta = rotationA + beta
  const minusRotAPlusBeta = -rotationA + beta

  if (dot === 0) {
    if (cross === -1) {
      if (rotationA === ninetyDeg) {
        return rotAPlusBeta
      }
      if (rotationA === oneEightyDeg) {
        return rotAPlusBeta
      }
      if (rotationA === -ninetyDeg) {
        return minusRotAMinusBeta
      }
      return minusRotAMinusBeta
    }
    if (cross === 1) {
      if (rotationA === -ninetyDeg) {
        return minusRotAPlusBeta
      }
      if (rotationA === oneEightyDeg) {
        return minusRotAPlusBeta
      }
      return rotAMinusBeta
    }

    return rotAMinusBeta
  }
  if (cross > 0 && dot > 0) {
    if (absoluteCross > 0) {
      return minusRotAPlusBeta
    }
    if (absoluteCross < 0) {
      return minusRotAMinusBeta
    }
  }
  if (cross > 0 && dot < 0) {
    if (absoluteCross > 0) {
      return minusRotAPlusBeta
    }
    if (absoluteCross < 0) {
      return minusRotAMinusBeta
    }
  }
  if (cross < 0 && dot > 0) {
    if (absoluteCross > 0) {
      return minusRotAPlusBeta
    }
    if (absoluteCross < 0) {
      return minusRotAMinusBeta
    }

    return rotAMinusBeta
  }
  if (cross < 0 && dot < 0) {
    if (absoluteCross < 0) {
      return minusRotAMinusBeta
    }
    if (absoluteCross > 0) {
      return minusRotAPlusBeta
    }

    if (absoluteCross < 0) {
      return rotAPlusBeta
    }
    if (absoluteCross > 0) {
      return minusRotAMinusBeta
    }
  }

  return 1
}
